import { render, staticRenderFns } from "./CustomerViewAccount.vue?vue&type=template&id=040f5a8a&scoped=true&"
import script from "./CustomerViewAccount.vue?vue&type=script&lang=js&"
export * from "./CustomerViewAccount.vue?vue&type=script&lang=js&"
import style0 from "./CustomerViewAccount.vue?vue&type=style&index=0&id=040f5a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040f5a8a",
  null
  
)

export default component.exports